
<div class="spinner-overlay" *ngIf="loadingMindMaps || loadingMindMapIdeas">
  <h3 class="text-white" *ngIf="loadingMindMaps">Loading mind maps from MindMeister</h3>
  <h3 class="text-white" *ngIf="loadingMindMapIdeas">Loading ideas from the selected mind map</h3>
  <p-progressSpinner></p-progressSpinner>
</div>


<section class="export-dialog">
<ng-container *ngIf="viewMode == 'settings'; then SETTINGS; else STATE"></ng-container>
<ng-template #SETTINGS>

  <div mat-dialog-content class="content-export">

    <h2 mat-dialog-title>Select the export location</h2>

    <section class="pl-2">
      <mat-radio-group [(ngModel)]="exportLocation" class="example-radio-group" (change)="error = '' ">


        <mat-radio-button class="example-radio-button" value="xmind">
          <span class="inline-flex">
            <img style="max-width: 32px" src="/assets/images/xmind.svg" />
            <span class="ml-2 w-12rem sm:w-21rem align-self-center">Xmind - Export as a file (.xmind)</span>
          </span>
        </mat-radio-button>

        <mat-radio-button class="example-radio-button" value="file">
          <span class="inline-flex">
            <img style="max-width: 32px" src="/assets/images/freeplane.png" />
            <span class="ml-2 w-12rem sm:w-21rem align-self-center">Freeplane - Export as a file (.mm)</span>
          </span>
        </mat-radio-button>

        <mat-radio-button *ngIf="false" class="example-radio-button" value="mindmeister">
          <span class="inline-flex">
            <img style="max-width: 32px" src="/assets/images/mindmeister.svg" />
            <span class="ml-2 w-12rem sm:w-21rem align-self-center">MindMeister - Export directly to MindMeister</span>
          </span>
        </mat-radio-button>
      </mat-radio-group>
    </section>


    <h2 *ngIf="(exportLocation == 'mindmeister') && isMindMeisterConnected()" mat-dialog-title class="mt-5">Select an option bellow</h2>

    <div *ngIf="(exportLocation == 'mindmeister') && !isMindMeisterConnected()" class="text-center my-4">
      <h2  mat-dialog-title class="text-left"> You haven't connected your account to MindMeister. Go to integrations to connect your account.</h2>
      <button mat-raised-button color="primary" routerLink="/integrations"  mat-button (click)="onNoClick()">Go to Integrations</button>
    </div>

    <section *ngIf="(exportLocation == 'mindmeister') && isMindMeisterConnected()" class="example-section pl-2">
      <mat-radio-group [(ngModel)]="exportLocationMindmeister"  (ngModelChange)="scrollToBottom()" class="example-radio-group" (change)="error = '' ">
        <mat-radio-button class="example-radio-button" value="new">Create a new Mind Map</mat-radio-button>
        <mat-radio-button class="example-radio-button" value="existing" (click)="getMindMeisterMaps()">Export into an existing Mind Map</mat-radio-button>
      </mat-radio-group>
    </section>

    <h2 *ngIf="(exportLocation == 'mindmeister') && (exportLocationMindmeister == 'existing')" mat-dialog-title
      class="mt-5">Select a Mind Map to export into</h2>

    <form *ngIf="(exportLocation == 'mindmeister') && (exportLocationMindmeister == 'existing')" class="mmForm">
      <mat-form-field class="pl-4 pr-4" appearance="fill" #autocompleteFieldMM>
        <mat-label>{{placeHolderMM}}</mat-label>
        <input type="text" matInput [matAutocomplete]="auto" [formControl]="myControlMM" #elementInput>
        <mat-autocomplete (optionSelected)="OnMMSelected($event.option.value)" #auto="matAutocomplete"
          [displayWith]="displayMMFn">
          <mat-option *ngFor="let option of filteredMaps | async" [value]="option">
            {{option.title}}
          </mat-option>
        </mat-autocomplete>
        <button *ngIf="mmSelected" matSuffix mat-icon-button aria-label="Clear"
          (click)="clearSelectedMindMap(autocompleteFieldMM, elementInput);">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon *ngIf="!mmSelected" matSuffix>search</mat-icon>
      </mat-form-field>
    </form>


    <h2 *ngIf="(exportLocation == 'mindmeister') && (exportLocationMindmeister == 'existing') && mmSelected" mat-dialog-title
      class="mt-2">[Optional] Select an idea inside the Mind Map to export into</h2>

    <form *ngIf="(exportLocation == 'mindmeister') && (exportLocationMindmeister == 'existing') && mmSelected"
      class="mmForm">
      <mat-form-field class="pl-4 pr-4" appearance="fill" #autocompleteFieldMMIdea>
        <mat-label> Idea inside the Mind Map</mat-label>
        <input type="text" matInput [matAutocomplete]="auto2" [formControl]="myControlMMIdea">
        <mat-autocomplete (optionSelected)="OnMMIdeaSelected($event.option.value)" #auto2="matAutocomplete"
          [displayWith]="displayMMIdeaFn">
          <mat-option *ngFor="let option of filteredIdeas | async" [value]="option">
            {{option.title}}
          </mat-option>
        </mat-autocomplete>
        <button *ngIf="mmIdeaSelected" matSuffix mat-icon-button aria-label="Clear" (click)="clearSelectedIdea();">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon *ngIf="!mmIdeaSelected" matSuffix>search</mat-icon>
      </mat-form-field>
    </form>

  </div>

  <mat-error *ngIf="error"  class="ml-4">{{error}}</mat-error>

  <mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button *ngIf="!((exportLocation == 'mindmeister') && !isMindMeisterConnected())" mat-button cdkFocusInitial (click)="export()">Export</button>
  </mat-dialog-actions>

</ng-template>

<ng-template #STATE>
  <ng-container *ngIf="viewMode == 'exporting'; then EXPORTING; else STATUS"> </ng-container>
  <ng-template #EXPORTING>
    <h3 class="px-4">Exporting...</h3>
    <p class="px-4"> Please, don't leave this page while exporting.</p>
    <mat-progress-bar mode="determinate"
      [value]="(mindmeisterService.nodesExported/mindmeisterService.nodesToExport)*100"></mat-progress-bar>
  </ng-template>
  <ng-template #STATUS>

    <h3 class="px-4" *ngIf="viewMode == 'success'">Notes Exported Succesfuly</h3>
    <a class="px-4" *ngIf="viewMode == 'success'" target="_blank"
      href='https://www.mindmeister.com/{{mindmeisterService.rootMindmeisterIdeaExported}}'>https://www.mindmeister.com/{{mindmeisterService.rootMindmeisterIdeaExported}}</a>

    <h3 class="px-4"  *ngIf="viewMode == 'fail'">Fail:</h3>
    <p class="px-4" *ngIf="viewMode == 'fail'">{{failMessage}}</p>

    <mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Close</button>
    </mat-dialog-actions>
  </ng-template>
</ng-template>
</section>
